import React from 'react';

import WorthTheWait from '@rbilabs/worth-the-wait';

import NotFound from 'pages/not-found';
import { useLocale } from 'state/intl';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLogger } from 'state/logger';
import { isNative } from 'utils/environment';
import noop from 'utils/noop';

export const BrewLTO = () => {
  const worthTheWaitFlagValue = useFlag(LaunchDarklyFlag.TH_WORTH_THE_WAIT);
  const { language, region } = useLocale();
  const logger = useLogger();

  if (!worthTheWaitFlagValue) {
    logger.warn('Attempting to access forbidden worth the wait campaign');
    return <NotFound />;
  }

  return (
    <WorthTheWait
      appHeaderHeight={0}
      appFooterHeight={0}
      isNative={isNative}
      language={language}
      mParticleLogEvent={noop}
      region={region}
    />
  );
};

export default BrewLTO;
